export interface NumberMaskOptions {
    decimalSeparator: string;
    alternativeDecimalSeparator: string;
    groupSeparator: string;
    precision?: number;
    groupSize?: number;
    allowNegativeNumber?: boolean;
}
